<template>
  <div
    class="lav-card__thumbnail"
    v-if="counselor"
    :class="{
      circular: useCircularImage,
      'has-video': hasVideo,
      'no-image': !imgixPath,
    }"
    @click.stop="hasVideo ? openVideoModal() : handleClick()"
  >
    <div class="counselor-image__thumbnail">
      <a
        :is="link && !hasVideo ? 'a' : 'span'"
        :href="link && !hasVideo ? link : null"
      >
        <ix-img
          loading="lazy"
          v-if="imgixPath"
          :alt="name"
          :height="imgixParams.h"
          :imgix-params="imgixParams"
          :src="imgixPath"
          :title="name"
          :width="imgixParams.w"
        />
        <img
          loading="lazy"
          v-else
          :alt="name"
          :height="imgixParams.h"
          :src="fallbackImage"
          :title="name"
          :width="imgixParams.w"
        />
      </a>
    </div>
    <button
      aria-expanded="false"
      aria-haspopup="dialog"
      aria-label="Play introduction video"
      class="btn secondary counselor-top-section__image-button counselor-video-modal__vue"
      v-if="hasVideo"
      @click.stop="openVideoModal()"
    >
      Video
    </button>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {

  beforeUnmount() {
    // Ensure modal is closed when component is destroyed
    if (this.isModalOpen) {
      this.closeModal();
    }
  },

  computed: {
    ...mapState('counselorVideo', ['isModalOpen']),

    hasVideo() {
      const video = this.counselor.video;
      return !!(
        video &&
        this.isTherapist &&
        (video.browser720_h264_encoded || video.video_webm || video.original)
      );
    },

    imgixParams() {
      if (!this.isList && this.useCircularImage) {
        return {
          crop: 'faces',
          fit: 'crop',
          h: 100,
          w: 100,
        };
      }

      return {
        crop: 'focalpoint',
        fit: 'crop',
        'fp-y': 0.45,
        h: 275,
        w: 400,
      };
    },

    imgixPath() {
      return this.counselor.imgix_path;
    },

    name() {
      return this.counselor.name;
    },
  },

  data() {
    return {
      fallbackImage: `${theme_vars.assetsUrl}/icons/users.svg`,
      isOpening: false,
      texts: theme_vars.counselorSlider,
    };
  },

  methods: {
    ...mapActions('counselorVideo', ['openModal', 'closeModal']),
    ...mapMutations('user', ['setName', 'setVideo']),

    handleClick() {
      if (this.link) {
        window.location.href = this.link;
      }
    },

    openVideoModal() {
      // Prevent rapid clicking or opening when already open
      if (this.isOpening || this.isModalOpen) {
        return;
      }

      this.isOpening = true;

      // Set counselor data in user store for the video modal to access
      this.setName(this.counselor.name);
      this.setVideo(this.counselor.video);

      this.openModal();

      // Reset the flag after a short delay
      setTimeout(() => {
        this.isOpening = false;
      }, 300);
    },
  },
  name: 'CounselorCardImage',

  props: {
    counselor: {
      required: true,
      type: Object,
    },
    isList: {
      default: false,
      type: Boolean,
    },
    isTherapist: {
      default: false,
      type: Boolean,
    },
    link: {
      default: '',
      type: String,
    },
    role: {
      default: '',
      type: String,
    },
    useCircularImage: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
